import { useState } from 'react'
import { errorMessage, unwrap } from 'api/call'
import { postHomeSendAllNotifications } from 'api/generated'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { showSubmittedData } from 'helpers/show-submitted-data'
import { toast } from 'sonner'

export const NotificationsPage = () => {
  const [content, setContent] = useState('')
  const [title, setTitle] = useState('')
  const [destinationUrl, setDestinationUrl] = useState('')
  const isValid = () => title !== '' && content !== ''
  const onClickFunction = () => {
    if (
      window.confirm(
        'Sei sicuro di voler inviare questa notifica a tutti gli utenti?'
      )
    ) {
      unwrap(
        postHomeSendAllNotifications({
          body: { title, content, destination_url: destinationUrl },
        })
      )
        .then(() =>
          toast.success('Job di invio notifiche lanciato con successo')
        )
        .catch((error) =>
          showSubmittedData(
            errorMessage(error, 'Errore sconosciuto'),
            "Errore durante l'invio della notifica"
          )
        )
    }
  }
  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Notifiche</h2>
            <p className='text-muted-foreground'>
              Invia notifiche a tutti gli utenti del database
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <div className='flex flex-col gap-5'>
            <Input
              placeholder='title'
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              className='h-8 w-[150px] lg:w-[250px]'
            />
            <Input
              placeholder='content'
              value={content}
              onChange={(event) => setContent(event.target.value)}
              className='h-8 w-[150px] lg:w-[250px]'
            />
            <Input
              placeholder='destination url'
              value={destinationUrl}
              onChange={(event) => setDestinationUrl(event.target.value)}
              className='h-8 w-[150px] lg:w-[250px]'
            />
            <div className=''>
              <Button disabled={!isValid()} onClick={onClickFunction}>
                Invia a tutti
              </Button>
            </div>
          </div>
        </div>
      </Main>
    </>
  )
}

export default NotificationsPage
